import { Controller } from "@hotwired/stimulus"
import PhotoSwipe from "photoswipe"

import { lightboxMotion, playWithSound, videoItemData, videoSlide } from "../lib/video_slide"

// A post card whose lead is a video (full phase 093, decision 11;
// `public/posts/_card`): its frame is a link to `<post path>#play` carrying
// the slide data of the post page's strip. A press opens that one slide in
// PhotoSwipe instead of the post — the same slide (`lib/video_slide.ts`), with
// a link «Открыть запись» to the post under the video — and plays it at once
// with sound, muted when the browser refuses sound; closing pauses it. One
// controller per link, so the cards `progressive-list` appends work too.
//
// A press with a modifier (a new tab, a new window) is the browser's, and the
// post page plays its lead on `#play` (`autoplay`); so does a page without
// this bundle. The fragment never reaches the server.
export default class VideoCardController extends Controller<HTMLAnchorElement> {
  static values = { post: String, openLabel: String }

  declare readonly postValue: string
  declare readonly openLabelValue: string

  private pswp: PhotoSwipe | null = null

  open(event: MouseEvent): void {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    event.preventDefault()
    const data = { ...videoItemData(this.element), postUrl: this.postValue, postLabel: this.openLabelValue }
    const pswp = new PhotoSwipe({ dataSource: [data], index: 0, ...lightboxMotion() })
    pswp.on("contentLoad", (loadEvent) => {
      if (loadEvent.content.type !== "video") return

      loadEvent.preventDefault()
      loadEvent.content.element = videoSlide(loadEvent.content.data)
    })
    pswp.on("contentActivate", ({ content }) => {
      const video = content.element?.querySelector("video")
      if (video) void playWithSound(video)
    })
    pswp.on("contentDeactivate", ({ content }) => {
      content.element?.querySelector("video")?.pause()
    })
    pswp.on("close", () => {
      pswp.currSlide?.content.element?.querySelector("video")?.pause()
    })
    pswp.on("destroy", () => {
      if (this.pswp === pswp) this.pswp = null
    })
    this.pswp = pswp
    pswp.init()
  }

  disconnect(): void {
    this.pswp?.destroy()
    this.pswp = null
  }
}
